export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manaubr.8966bea8.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};